import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import dateHelper from './dateHelper';

export default class History extends React.Component{
    render(){
        return(
            <Table style={{backgroundColor:'#ccc'}}>
                <TableHead>
                    {this.props.rows && this.props.rows.length > 0?
                    <TableRow>
                        <TableCell>Who</TableCell>
                        <TableCell>What</TableCell>
                        <TableCell>When</TableCell>
                    </TableRow> : ''}
                </TableHead>
                <TableBody>
                       { (this.props.rows || []).map((row,index) => (
                            <TableRow key={index}>
                                <TableCell>{row.who}</TableCell>
                               <TableCell>{row.what}</TableCell>
                               <TableCell>{dateHelper.toShortDate(row.when)}</TableCell>
                            </TableRow>
                        ))
                        }
                </TableBody>
            </Table>
        );
    }
}